import {COURSE_BADGE_PREMIUM} from '@udemy/browse-course';

export const browseCourseContextProps = {
    browseBadgeHandlerOptions: {
        numberOfBadgesToShow: 2, // same as default, explicit definition for clarity
        priority: {[COURSE_BADGE_PREMIUM]: Number.MAX_SAFE_INTEGER},
    },
};

export const minimalBrowseCourseContextProps = {
    browseBadgeHandlerOptions: {
        numberOfBadgesToShow: 1, // new default is 2; @see BrowseCourseBadgeHandler.defaultOptions
        priority: {[COURSE_BADGE_PREMIUM]: Number.MAX_SAFE_INTEGER}, // prioritize regular badges over premium
    },
};
